export default __webpack_public_path__ + "static/media/clock.560a9e76.svg";